// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';

const PipViews = props =>
    <section>
        {props.children}
    </section>;

PipViews.displayName = 'PipViews';
PipViews.propTypes = {
    children: PropTypes.node
};

export default PipViews;



// WEBPACK FOOTER //
// ./src/pip/shared/components/pip-views.js